import { MagicRequest } from './magicRequest';
import { NetworkManager } from './networkManager';

export const COMPANY_ID_HEADER = 'X-Company-Id';

export class BaseNetworkManager implements NetworkManager {
  public sendRequest = async (request: MagicRequest): Promise<Response> => {
    if (request.companyId) {
      request.headers.set(COMPANY_ID_HEADER, request.companyId);
    }
    return await fetch(request.url, {
      method: request.method,
      headers: request.headers,
      body: request.body,
      credentials: 'omit',
    });
  };
}

export const baseNetworkManager = new BaseNetworkManager();
